import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaServer } from 'react-icons/fa';
import './SAPServicesPage.css';

// Data for all SAP Managed Services
const sapServices = [
  {
    key: 'hosting',
    title: 'SAP Hosting',
    // icon: <FaServer style={{ color: '#3686d3', marginRight: 10, fontSize: 22 }} />,
    details: [
      'SAP Basis and Support',
      'Database Administration',
      'Installs, Upgrades, and Enhancements',
      'Management of Incidents, Problems, and Change',
      'Capacity',
      'Operating System Administration',
      'Infrastructure',
    ],
    description:
      'Managing your own data centres and associated infrastructure is becoming increasingly complicated and expensive due to the ever-changing technology landscape and concomitant legal constraints. Using our SAP cloud solutions, which are hosted in highly secure German data centres, guarantees that your organisation is always compliant with regulatory standards and on the cutting edge of technology. Using flexible and needs-based scalability, you can keep costs low, and Znotec’s qualified SAP specialists will keep your SAP Basic working smoothly around the clock.',
  },
  {
    key: 'cloud',
    title: 'SAP Cloud',
    details: [
      'Coordination of Services',
      'Platinum Services',
      'Hypercare Services',
      'Service Level Reporting',
      'Single Source Management',
      'Value-Add Services',
    ],
    description: 'SAP Cloud enables your business to be more agile and scalable. Benefit from a wide range of cloud-based SAP solutions to help you grow and innovate.',
  },
  {
    key: 'hana',
    title: 'SAP HANA & S/4HANA',
    details: [
      'SAP HANA (High-performance Analytic Appliance) is a multi-model database that keeps information in its memory rather than on a disc. The column-oriented in-memory database design permits the execution of complex analytics alongside high-speed transactions – all within a single system.'
    ],
    description: 'High-speed, real-time analytics and business intelligence with SAP HANA and S/4HANA. Transform your business operations with next-gen ERP and data management.',
  },
  {
    key: 'remote',
    title: 'SAP Remote Managed Services',
    details: [
      'Application Support and Testing',
      'Break/Fix',
      'Application Optimization and Enhancements',
      'Modifications to the Application',
      'SAP Releases',
      'SAP Upgrades',
      'New SAP applications',
    ],
    description: 'Let our remote experts handle your SAP landscape. Secure, reliable, and always available support for your enterprise needs.',
  },
  {
    key: 'delivery',
    title: 'SAP Service Delivery Management',
    details: [
      'Planned and ad-hoc service delivery',
      'Performance monitoring',
      'Incident and problem management',
      'Change management',
    ],
    description: 'Dedicated service delivery managers ensure your SAP projects are on track and your operations are efficient.',
  },
  {
    key: 'maintenance',
    title: 'SAP Maintenance',
    details: [
      'SAP Maintenance Assistance',
      'Software Updates',
      'SAP Service Exchange',
      'Ongoing Issues and Recommendations',
    ],
    description: 'Comprehensive maintenance services to keep your SAP solutions updated, optimized, and fully supported.',
  },
  {
    key: 'ams',
    title: 'SAP Application Managed Services (AMS)',
    details: [
      'Application Support and Testing',
      'Break/Fix',
      'Application Optimization and Enhancements',
      'Modifications to the Application',
      'SAP Releases',
      'SAP Upgrades',
      'New SAP applications',
    ],
    description: 'From daily operations to optimization, our AMS team is your partner for managing SAP applications.',
  },
  {
    key: 'security',
    title: 'SAP Security',
    details: [
      'Security Strategy and Planning',
      'Vulnerability Assessment and Management',
      'Endpoint Protection',
      'Perimeter Security (Firewall and IDPS)',
      'Security Information and Event Management (SIEM)',
      'Single Sign-On (SSO)',
    ],
    description: 'Protect your business with SAP security solutions and proactive risk management.',
  },
  {
    key: 'continuity',
    title: 'SAP Business Continuity',
    details: [
      'High Availability',
      'Disaster Recovery',
      'Backups',
    ],
    description: 'Ensure uninterrupted business operations with comprehensive continuity planning and solutions.',
  },
];


// const SAPServicesHero = () => (
    
//   <div className="sap-hero-section">
//     <div className="sap-hero-overlay">
//       <Container className="sap-hero-content text-center">
//         <h1 className="sap-hero-title">SAP with Znotec</h1>
//         <p className="sap-hero-desc">
//           The SAP services we provide are geared to your business requirements. They are safeguarded by the finest quality hardware and security measures, top-tier security and safety measures, reliability of systems, and protection of sensitive information.
//         </p>
//         <Button className="sap-hero-btn" size="lg">
//           Get a consultation
//         </Button>
//       </Container>
//     </div>
//   </div>
// );


const SAPManagedServices = () => {
  // Initially, select the first service
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <>
    <div className="sap-hero-section">
        <div className="sap-hero-overlay">
        <Container className="sap-hero-content text-center">
            <h1 className="sap-hero-title">SAP with Znotec</h1>
            <p className="sap-hero-desc">
            The SAP services we provide are geared to your business requirements. They are safeguarded by the finest quality hardware and security measures, top-tier security and safety measures, reliability of systems, and protection of sensitive information.
            </p>
            <Button className="sap-hero-btn" size="lg">
                <a href="/contact">Get a consultation</a>
            </Button>
        </Container>
        </div>
    </div>
    
    <section className="sap-managed-services-section py-5">
      <Container>
        <h3 className='text-center sap-managed-services-title mb-4'>SAP managed services</h3>
        <h6 className="text-center mb-4">Znotec is a SAP Managed Services provider that covers the compliance, data protection, scalability, and availability needs of an organization’s SAP systems.</h6>
        <h3 className="text-center sap-managed-services-title mb-4">
          Below are SAP Managed Services provider by Znotec:
        </h3>
        <Row className="justify-content-center">
          <Col xs={12} md={5} lg={4} className="mb-4">
            <div className="sap-service-list">
              {sapServices.map((service, idx) => (
                <Button
                  key={service.key}
                  className={`sap-service-btn ${idx === selectedIndex ? 'active' : ''}`}
                  onClick={() => setSelectedIndex(idx)}
                  variant="outline-primary"
                  block="true"
                >
                  {idx === 0 && (
                    <FaServer style={{ color: idx === selectedIndex ? '#fd823e' : '#3686d3', marginRight: 12, fontSize: 22 }} />
                  )}
                  {service.title}
                </Button>
              ))}
            </div>
          </Col>
          <Col xs={12} md={7} lg={6}>
            <div className="sap-service-details">
              {/* Show either list or description or both, depending on data */}
              {sapServices[selectedIndex].details.length > 1 ? (
                <ul className="sap-service-details-list">
                  {sapServices[selectedIndex].details.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="sap-service-details-desc">{sapServices[selectedIndex].details[0]}</p>
              )}
              {sapServices[selectedIndex].description && sapServices[selectedIndex].details.length > 1 && (
                <div className="sap-service-description mt-3">{sapServices[selectedIndex].description}</div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
};

export default SAPManagedServices;
